import React from "react";

// Inputs should feel like part of the product, not browser chrome (§9):
// 44px tall, #CBD5E1 border, 8px radius, blue focus ring.
const CONTROL =
  "w-full h-11 rounded-sm border border-border-strong bg-surface px-3 text-sm text-navy placeholder:text-muted focus-ring transition-colors disabled:bg-bg disabled:text-muted";

export const Label = ({ htmlFor, children, className = "" }) => (
  <label
    htmlFor={htmlFor}
    className={`mb-1.5 block text-xs font-semibold uppercase tracking-wide text-muted ${className}`}
  >
    {children}
  </label>
);

// These forward refs: the auth and profile forms are uncontrolled and read
// their values off a ref, so a plain function component would silently drop
// the ref and submit undefined.
export const Input = React.forwardRef(({ className = "", icon, ...props }, ref) => {
  if (!icon) {
    return <input ref={ref} className={`${CONTROL} ${className}`} {...props} />;
  }
  return (
    <div className="relative">
      <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-muted">
        {icon}
      </span>
      <input ref={ref} className={`${CONTROL} pl-9 ${className}`} {...props} />
    </div>
  );
});
Input.displayName = "Input";

export const Textarea = React.forwardRef(
  ({ className = "", rows = 4, ...props }, ref) => (
    <textarea
      ref={ref}
      rows={rows}
      className={`w-full rounded-sm border border-border-strong bg-surface p-3 text-sm text-navy placeholder:text-muted focus-ring transition-colors ${className}`}
      {...props}
    />
  )
);
Textarea.displayName = "Textarea";

export const Select = React.forwardRef(({ className = "", children, ...props }, ref) => (
  <div className="relative">
    <select
      ref={ref}
      className={`${CONTROL} cursor-pointer appearance-none pr-9 ${className}`}
      {...props}
    >
      {children}
    </select>
    <svg
      className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      aria-hidden="true"
    >
      <path d="m6 8 4 4 4-4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </div>
));
Select.displayName = "Select";

export const SearchIcon = (props) => (
  <svg
    className="h-4 w-4"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    aria-hidden="true"
    {...props}
  >
    <circle cx="9" cy="9" r="6" />
    <path d="m13.5 13.5 3.5 3.5" strokeLinecap="round" />
  </svg>
);
